var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9D1C1BC-B3D3-41C4-B8A0-8AED2D7B82AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1100,
    height: 960
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 520,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 1660,
    height: 950
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 1120,
    height: 600
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9144389,4.05928711 L10.859021,0.0884179687 C10.8012859,0.0319335938 10.721632,0 10.6384337,0 L4.59412348,0 C3.91768678,0 3.36735328,0.518378906 3.36735328,1.15552734 L3.36735328,5.19231445 L0.91782358,5.19231445 C0.411731908,5.19231445 0,5.58017578 0,6.05695312 L0,10.3853906 C0,10.8621387 0.411731908,11.25 0.91782358,11.25 L3.36735328,11.25 L3.36735328,13.8464941 C3.36735328,14.4825293 3.91768678,15 4.59412348,15 L13.7732298,15 C14.4496665,15 15,14.4828223 15,13.8471387 L15,4.25932617 C15,4.18473633 14.9693136,4.11304688 14.9144389,4.05928711 Z M10.7142946,0.778740234 L14.0434376,4.03845703 L10.7142946,4.03845703 L10.7142946,0.778740234 Z M14.3877342,13.8471387 C14.3877342,14.1647168 14.1120544,14.4230859 13.7731987,14.4230859 L4.59412348,14.4230859 C4.25526777,14.4230859 3.97958803,14.1644531 3.97958803,13.8465234 L3.97958803,11.25 L9.18423627,11.25 C9.69032794,11.25 10.1020599,10.8621387 10.1020599,10.3853906 L10.1020599,6.05695313 C10.1020599,5.58017578 9.69032794,5.19231445 9.18423627,5.19231445 L3.97958803,5.19231445 L3.97958803,1.15552734 C3.97958803,0.836455078 4.25526777,0.576914063 4.59412348,0.576914063 L10.1020288,0.576914063 L10.1020288,4.32691406 C10.1020288,4.48623047 10.2391069,4.61537109 10.4081461,4.61537109 L14.3877342,4.61537109 L14.3877342,13.8471387 Z M2.47429551,6.96684088 L3.03598629,6.96684088 L3.03598629,8.59135884 C3.03598629,8.80376096 3.01567677,8.96714475 2.97505712,9.08151512 C2.92047447,9.23089683 2.82146556,9.35080886 2.67802742,9.44125482 C2.53458928,9.53170078 2.34545687,9.57692308 2.11062452,9.57692308 C1.83517252,9.57692308 1.62319191,9.50602618 1.47467631,9.36423026 C1.32616072,9.22243434 1.25126936,9.01441176 1.25,8.74015628 L1.7812262,8.68413842 C1.78757302,8.83118604 1.8110559,8.93505145 1.85167555,8.99573777 C1.91260503,9.08793429 2.00526721,9.13403187 2.12966489,9.13403187 C2.25533193,9.13403187 2.34418608,9.10106335 2.39623001,9.03512533 C2.44827393,8.96918731 2.47429551,8.83235338 2.47429551,8.62461944 L2.47429551,6.96684088 Z M3.63575781,9.53315912 L3.63575781,6.96684088 L4.54017517,6.96684088 C4.88290347,6.96684088 5.10630819,6.97967817 5.21039604,7.00535316 C5.37033591,7.04386563 5.50425181,7.12759982 5.61214775,7.25655825 C5.7200437,7.38551668 5.77399086,7.5521098 5.77399086,7.7563426 C5.77399086,7.91389362 5.74289191,8.0463512 5.68069307,8.1537193 C5.61849423,8.26108741 5.5394775,8.34540511 5.44364052,8.40667495 C5.34780353,8.4679448 5.2503813,8.50849899 5.15137091,8.52833875 C5.01681832,8.55284668 4.82197386,8.56510047 4.56683168,8.56510047 L4.19935263,8.56510047 L4.19935263,9.53315912 L3.63575781,9.53315912 Z M4.19935263,7.4009793 L4.19935263,8.12921149 L4.50780655,8.12921149 C4.72994526,8.12921149 4.87845863,8.11579068 4.9533511,8.08894865 C5.02824358,8.06210662 5.08695079,8.02009365 5.12947449,7.96290846 C5.17199818,7.90572328 5.19325971,7.83920273 5.19325971,7.76334483 C5.19325971,7.66998127 5.1634301,7.59295748 5.10376999,7.53227116 C5.04410988,7.47158484 4.96858385,7.43365646 4.87718964,7.41848488 C4.80991335,7.40681443 4.6747281,7.4009793 4.47162986,7.4009793 L4.19935263,7.4009793 Z M7.53522468,8.58960828 L7.53522468,8.15722042 L8.75,8.15722042 L8.75,9.17954638 C8.63194914,9.28458039 8.4609049,9.37706729 8.23686215,9.45700984 C8.01281939,9.5369524 7.78592397,9.57692308 7.55616908,9.57692308 C7.26421535,9.57692308 7.00971167,9.52061402 6.79265042,9.40799422 C6.57558917,9.29537441 6.41247833,9.13432467 6.30331302,8.92484017 C6.19414772,8.71535566 6.13956588,8.48749362 6.13956588,8.24124721 C6.13956588,7.973994 6.20049444,7.73650398 6.32235339,7.52877004 C6.44421234,7.3210361 6.62255531,7.16173691 6.85738766,7.05086767 C7.03636799,6.96567341 7.25913804,6.92307692 7.52570449,6.92307692 C7.87224088,6.92307692 8.1429287,6.98988922 8.33777609,7.12351583 C8.53262347,7.25714244 8.65797129,7.44182448 8.71382331,7.67756749 L8.15403656,7.77384818 C8.11468627,7.64780737 8.04074692,7.54831831 7.9322163,7.47537802 C7.82368567,7.40243773 7.68818309,7.36596813 7.52570449,7.36596813 C7.27944787,7.36596813 7.0836514,7.4377403 6.93830922,7.58128679 C6.79296703,7.72483327 6.72029703,7.93781572 6.72029703,8.22024051 C6.72029703,8.52483915 6.79391904,8.75328471 6.94116527,8.90558403 C7.0884115,9.05788335 7.28135194,9.13403187 7.51999238,9.13403187 C7.63804324,9.13403187 7.75640966,9.11273362 7.8750952,9.07013649 C7.99378074,9.02753936 8.09564568,8.97589842 8.18069307,8.9152121 L8.18069307,8.58960828 L7.53522468,8.58960828 Z",
    id: "path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-Retailer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-4.5_Retailer_Project_01",
    transform: "translate(-747.000000, -667.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1130
  })), /*#__PURE__*/React.createElement("g", {
    id: "Conteainer",
    transform: "translate(219.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  }), /*#__PURE__*/React.createElement("g", {
    id: "Backgorund",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  })), /*#__PURE__*/React.createElement("g", {
    id: "Block_Left",
    transform: "translate(20.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1100,
    height: 670
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(20.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.000000, 40.000000)",
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 540,
    height: 40
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Overlay"
  }, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.3,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 1920,
    height: 1130
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(130.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Bound",
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)",
    id: "Block_Left"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 160.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    stroke: "#EEF1F7",
    fill: "#EEF1F7",
    x: 0.5,
    y: 0.5,
    width: 1079,
    height: 109
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 70.000000)",
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF17-Background",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF10-Icon",
    transform: "translate(7.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_file_jpg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-10)",
    fill: "#2CCB8D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Color",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.3e108722ac4d4cec1d38458454e0acc7.svg";
export { ForwardRef as ReactComponent };